import { SetStateAction, useMemo } from 'react'

import debounce from 'debounce'
import { Button, Modal, Select } from 'flowbite-react'

import Loader from '@/components/Loader'
import TableItem from '@/components/Table'
import PaginationItem from '@/components/Table/pagination-item'
import SearchTableItem from '@/components/Table/search'
import { useRevisarPedidosContext } from '@/contexts/revisar-pedido.context'
import { ITarifasPedidoModalProps } from '@/interfaces/tarifas'
import { TABLE_HEADERS_TARIFAS } from '@/pages/Pedidos/constants'

const TarifasPedidoModal = ({
  onClose,
  isOpen
}: ITarifasPedidoModalProps) => {
  const {
    isLoadingRepasses,
    repassesList,
    repassesPageSize,
    setRepassesPageSize,
    repassesTotalPages,
    setRepassesPage,
    setSearch
  } = useRevisarPedidosContext()
  const handleSearch = debounce((e: SetStateAction<string>) => {
    setSearch(e)
  }, 500)

  const mappedTarifas = useMemo(() => {
    return repassesList?.conteudo?.resultados?.map(item => {
      return {
        descricao: item?.descricao,
        valorTotal: item?.valorTotal.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL'
        })
      }
    })
  }, [repassesList])
  return (
    <div data-testid='modal-tarifas'>
      <Modal
        show={isOpen}
        onClose={onClose}
        className='flex items-center'
        size='5xl'
      >
        <Modal.Header>
          <p className='text-center font-bold p-3'>Lista de Tarifas</p>
        </Modal.Header>
        <Modal.Body>
        
            <div data-testid='table-tarifas'>
              <SearchTableItem
                isAddItem={false}
                isSearchInputEnabled={true}
                setFilterText={e => handleSearch(e)}
              />
                {isLoadingRepasses ? (
            <div
              className='h-96 w-full flex justify-center items-center'
              data-testid='loader-tarifas'
            >
              <Loader size={'xl'} />
            </div>
          ) : (
            <>
              <TableItem
                isActions={false}
                isRowClicable={false}
                data={mappedTarifas || []}
                headers={TABLE_HEADERS_TARIFAS}
                deleteAction={() => void 0}
                hasCustomActions={false}
                idKey='pedidoId'
                isIdle={false}
              />
              <PaginationItem
                totalItems={
                  repassesList?.conteudo?.quantidadeDeItems ?? (0 as number)
                }
                totalPages={repassesTotalPages}
                pageSize={repassesPageSize}
                onPageChange={(pageParam: number) => setRepassesPage(pageParam)}
              >
                <Select
                  id='select-page-size'
                  data-testid='select-page-size'
                  onChange={e => setRepassesPageSize(Number(e.target.value))}
                >
                  <option value='10'>10</option>
                  <option value='25'>25</option>
                  <option value='50'>50</option>
                  <option value='100'>100</option>
                </Select>
              </PaginationItem>
            </>
          )}
        </div>
        </Modal.Body>
        <Modal.Footer>
          <div className='flex gap-2'>
            <Button color='gray' onClick={onClose} data-testid='btn-close'>
              Fechar
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default TarifasPedidoModal
